<template>
 <div>
			<div class="container container--small pdt-30 pdb-50">
<form @submit.prevent="next()" novalidate>
				<div class="pdl-24 pdr-24">
					<div class="t-headline11 font-m mgt-20 mgb-8">{{$t('1549')}}</div>
					<div class="d-flex">
						<!-- <div class="t-subtitle2 font-b">직무 A 직책 B</div> -->
						<div class="body1 font-r t-color-bodyGrayA" v-html="$t('762', {str1: `<strong>${join.dutyName}</strong>`, str2: `<strong>${join.responsibilityName}</strong>`})"></div>
					</div>

					<div class="mgt-40 mgb-28">
						<label
							class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
							data-mdc-auto-init="MDCTextField" 
							:class="submitState && codeInvalidCheck ? 'mdc-text-field--invalid' : ''"
								id="codeEl">
							<span class="mdc-notched-outline">
								<span class="mdc-notched-outline__leading"></span>
								<span class="mdc-notched-outline__notch">
									<span class="mdc-floating-label" id="password-message">{{$t('763')}}</span>
								</span>
								<span class="mdc-notched-outline__trailing"></span>
							</span>
							<input class="mdc-text-field__input" type="text" 
								aria-labelledby="password-message" 
								v-model="code"
								v-validate="'required|alpha_num'"
								ref="code"
								id="code"
								name="code"
								maxlength="50"
								required
							>
							<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing"
								tabindex="0" role="button">report_problem</i>
						</label>
						<div class="mdc-text-field-helper-line d-block">
							<div
								class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r ">
								{{$t('1552')}}
							</div>
						</div>
					</div>


					<div class="mgt-30">
						<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8"
							type="submit" @click="nextCheck" @keypress="nextCheck" tabindex="0">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">{{$t('1553')}}</span>
						</button>
						<button class="mdc-button  t-color-secondaryBtnText mgr-8" @click="cancelJoin()"  @keypress="cancelJoin()" tabindex="0">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">{{$t('1554')}}</span>
						</button>
					</div>
					<div class="mgt-24">
						<div class="">
							<a @click="showMessage(1)" @keypress="showMessage(1)" tabindex="0" class="t-body3 font-r t-color-signBlue">{{$t('764')}}</a>
							<span class="t-body3 font-r t-color-signGray pdl-2 pdr-2">{{$t('1556')}}</span>
							<a @click="showMessage(2)" @keypress="showMessage(2)" tabindex="0" class="t-body3 font-r t-color-signBlue">{{$t('765')}}</a>
						</div>
					</div>
				</div>
</form>
			</div>
 </div>
	
</template>

<script>
/**
 * 회원가입 - 코드인증 컴포넌트(sign up - auth code component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import joinApi from '@/api/joinApi.js'
import {mapState, mapMutations} from 'vuex'
import {joinMixin} from '@/mixins/join.js'

export default {
	data() {
		return {
			code: '',
			codeTextField: null,
			submitState: false,
			validIcon: ''
		}
	},

	mixins: [joinMixin],
	
	computed : {
		...mapState('join',{
			join : state => state,
		}),
	   
		// code 유효성 Check 및 아이콘(validation code & set icon)
		codeInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('code')) {
					returnValue = true
					this.validIcon = 'warning'
				}else {
					returnValue = false
					this.validIcon = ''
				}
			}
			this.codeTextField.valid === !returnValue ? '' : this.codeTextField.valid = !returnValue
			return returnValue
		},

	},
	created() {
		if (!this.join.responsibility) {
			this.moveJoin2Intro()
		}
	},
	mounted() {
		this.setMaterialUi()
		this.$refs.code.focus()
	},

	methods: {
		// Store 변이 정의(define store mutation)
		...mapMutations('join', ['SET_RESPONSIBILITY', 'SET_CODE']),

		setMaterialUi() {
			this.codeTextField = new MDCTextField(document.querySelector('#codeEl'))
			this.codeTextField.useNativeValidation = false
			window.mdc.autoInit();
const selector = '.mdc-button, .mdc-list, .mdc-list-item, .mdc-card__primary-action, .mdc-chip-set';
// const buttonRipple = [].map.call(document.querySelectorAll(selector), function (el) {
//     mdc.ripple.MDCRipple.attachTo(el);
// })
if(document.querySelector('.mdc-text-field')){
    var textField = new MDCTextField(document.querySelector('.mdc-text-field'));
}
			const buttonRipple = [].map.call(document.querySelectorAll(selector), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},
		// 다음(move next)
		nextCheck() {
			//alert('snack alert')
			this.$validator.validateAll().then((resultValid) => {
				this.submitState = true

				if (resultValid) {
					let params = {
						responsibility: this.join.responsibility,
						code: this.code
					}

					// code auth
					joinApi.authResponsibility(params).then((response) => {
						this.SET_CODE(this.code)
						if (this.join.socialLink.type === 'google' || this.join.socialLink.type === 'facebook' || this.join.socialLink.type === 'firebase') {
							this.$router.push({
								name: 'Join2SocialInput', query: this.$route.query
							})
						}else {
							this.$router.push({
								name: 'Join2Name', query: this.$route.query
							})
						}
						
					}).catch((err) => {
						//alert('snack alert');
						// this.$snackOpen({contents:'인증에 실패했습니다. 코드를 확인해주세요.', btnDisplayYN: false}).then(() => {})
						this.$snackOpen({contents: this.$t('1558') + ' ' + this.$t('1559'), btnDisplay:''}).then(() => {})
					})
			
				} else{
					this.focusFirstInvalidElement()
				}
			})
		},

	},

	

}
</script>